import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	numberPlaceholderMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	validNumberErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	numberSizeLimitErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	numberPlaceholderMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-placeholder-message',
		defaultMessage: 'Enter a number',
		description: 'Placeholder for the number picker input',
	},
	validNumberErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.valid-number-error-message',
		defaultMessage: 'Please enter a valid number',
		description: 'Display error when the user has entered an invalid number',
	},
	numberSizeLimitErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-size-limit-error-message',
		defaultMessage: 'Specify a number for the custom field (below {maxSize})',
		description: 'Display error when the user has exceeded the number size limit',
	},
});
export default messages;
